// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-mobile-mobile-wrapper-mobile-wrapper-styles__contentWrapper {
  padding: 1.2rem 2.4rem;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__contentBlock {
  width: 100%;
  max-width: 45rem;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__fullPageDefault {
  height: 100%;
  width: 100%;
  background-color: var(--cps-color-ash);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.4rem 0;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__fullPage {
  height: 100%;
  width: 100%;
  background-color: var(--cps-color-ash);
  background-size: cover;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__pageContent {
  border-radius: 2rem;
  width: 100%;
  padding: 2.4rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--cps-color-ash);
  position: absolute;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__headerImage {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 18.8rem;
  margin: -3.2rem 0;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__emailCard {
  padding: 3rem;
  margin: 0 auto;
  width: 70%;
  height: 42%;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__welcome {
  display: flex;
  justify-content: center;
  font-size: 2.4rem;
  color: var(--cps-color-primary);
  font-weight: 500;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__greetingWrapper {
  position: relative;
  top: -75%;
  margin: 0 2.4rem;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__greetingTitle {
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 3rem;
  color: var(--cp-color-app-primary-dark-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.src-mobile-mobile-wrapper-mobile-wrapper-styles__greetingDescription {
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.8rem;
  color: var(--cp-color-app-primary-dark-text);
  -webkit-line-clamp: 3;
  display: -webkit-box;
  overflow: hidden;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/mobile-wrapper/mobile-wrapper.styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;AACzB","sourcesContent":[".contentWrapper {\n  padding: 1.2rem 2.4rem;\n}\n\n.contentBlock {\n  width: 100%;\n  max-width: 45rem;\n}\n\n.fullPageDefault {\n  height: 100%;\n  width: 100%;\n  background-color: var(--cps-color-ash);\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2.4rem 0;\n}\n\n.fullPage {\n  height: 100%;\n  width: 100%;\n  background-color: var(--cps-color-ash);\n  background-size: cover;\n}\n\n.pageContent {\n  border-radius: 2rem;\n  width: 100%;\n  padding: 2.4rem 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--cps-color-ash);\n  position: absolute;\n}\n\n.headerImage {\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 18.8rem;\n  margin: -3.2rem 0;\n}\n\n.emailCard {\n  padding: 3rem;\n  margin: 0 auto;\n  width: 70%;\n  height: 42%;\n}\n\n.welcome {\n  display: flex;\n  justify-content: center;\n  font-size: 2.4rem;\n  color: var(--cps-color-primary);\n  font-weight: 500;\n}\n\n.greetingWrapper {\n  position: relative;\n  top: -75%;\n  margin: 0 2.4rem;\n}\n\n.greetingTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  line-height: 3rem;\n  color: var(--cp-color-app-primary-dark-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.greetingDescription {\n  font-size: 1.4rem;\n  font-weight: 700;\n  line-height: 1.8rem;\n  color: var(--cp-color-app-primary-dark-text);\n  -webkit-line-clamp: 3;\n  display: -webkit-box;\n  overflow: hidden;\n  /* autoprefixer: ignore next */\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `src-mobile-mobile-wrapper-mobile-wrapper-styles__contentWrapper`,
	"contentBlock": `src-mobile-mobile-wrapper-mobile-wrapper-styles__contentBlock`,
	"fullPageDefault": `src-mobile-mobile-wrapper-mobile-wrapper-styles__fullPageDefault`,
	"fullPage": `src-mobile-mobile-wrapper-mobile-wrapper-styles__fullPage`,
	"pageContent": `src-mobile-mobile-wrapper-mobile-wrapper-styles__pageContent`,
	"headerImage": `src-mobile-mobile-wrapper-mobile-wrapper-styles__headerImage`,
	"emailCard": `src-mobile-mobile-wrapper-mobile-wrapper-styles__emailCard`,
	"welcome": `src-mobile-mobile-wrapper-mobile-wrapper-styles__welcome`,
	"greetingWrapper": `src-mobile-mobile-wrapper-mobile-wrapper-styles__greetingWrapper`,
	"greetingTitle": `src-mobile-mobile-wrapper-mobile-wrapper-styles__greetingTitle`,
	"greetingDescription": `src-mobile-mobile-wrapper-mobile-wrapper-styles__greetingDescription`
};
export default ___CSS_LOADER_EXPORT___;
